import { resolveLocaleFromPath, type Locale } from '../i18n';

/**
 * Payme's `error.message` is `{ ru, uz, en }`. Pick the page's language: an
 * Uzbek buyer used to read «Превышено число попыток» in Russian on the Uzbek
 * sheet (tester, 2026-09-22), because this always took `.ru`. `kk` has no
 * Payme text, and a missing language falls back to Russian, then English.
 *
 * Its own module, deliberately: the card sheet reads it for a refusal the API
 * relays (`charge_failed` carries the same `{ru, uz, en}` under `messages`),
 * and the sheet's tests mock the Payme client module wholesale — a helper that
 * lived there was `undefined` under test and the branch threw.
 */
export function gatewayMessage(
  message: string | Record<string, string | undefined>,
  locale: Locale = typeof window === 'undefined'
    ? 'ru'
    : resolveLocaleFromPath(window.location.pathname),
): string {
  if (typeof message === 'string') return message;
  return message[locale] ?? message.ru ?? message.en ?? JSON.stringify(message);
}
